<a
  *ngIf="href"
  [class.lg]="size === 'lg'"
  [class.primary]="color === 'primary'"
  [ngClass]="classes"
  [routerLink]="href"
>
  <app-ui-icon color="var({{ iconColor }})" name="{{ icon }}"></app-ui-icon>
</a>
<button
  (click)="onClick.emit($event)"
  *ngIf="!href"
  [attr.aria-label]="ariaLabel"
  [class.lg]="size === 'lg'"
  [class.primary]="color === 'primary'"
  [disabled]="disabled"
  [ngClass]="classes"
  type="button"
>
  <app-ui-icon color="var({{ iconColor }})" name="{{ icon }}"></app-ui-icon>
</button>
